import { useNavigate } from "react-router-dom"

import {
  MetricHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
  MetricHeaderWrapper,
} from "../Atom"
import { HeaderInfoNav } from "../Reusable"
import { DropdownFilter } from "../../Dropdown"
import {
  ProvidersHeaderGeneralDropdownFilter,
  ProvidersHeaderProviderDropdownFilter,
} from "../../Dropdown/ProvidersHeaderDropdownFilter"
import { useSelector } from "react-redux"
import { OutlinedInput, SelectChangeEvent } from "@mui/material"
import { useDispatch } from "react-redux"
import {
  setIsAllGroupSelected,
  setIsAllOfficeSelected,
  setIsAllRegionSelected,
  setProvidersData,
  setProvidersList,
  setProvidersMetricTabs,
  setProvidersTableData,
  setSelectedProviderMetrics,
  setSelectedProviders,
  setSelectedProvidersGroups,
  setSelectedProvidersMetricTab,
  setSelectedProvidersOffices,
  setSelectedProvidersRegions,
  setSelectedSpeciality,
} from "../../../redux/slices/providersSlice"
import ProvidersHeaderGeneralDropdownMultiFilter from "../../Dropdown/ProvidersHeaderDropdownFilter/ProvidersHeaderGeneralDropdownMultiFilter"
import ProvidersHeaderBasicDropdownMultiFilter from "../../Dropdown/ProvidersHeaderDropdownFilter/ProvidersHeaderBasicDropdownMultiFilter"
import ProvidersHeaderProviderBasicDropdownFilter from "../../Dropdown/ProvidersHeaderDropdownFilter/ProvidersHeaderProviderBasicDropdownFilter"
import MultiSelect from "../../Dropdown/ProvidersHeaderDropdownFilter/MultiSelect"
import { useEffect, useState } from "react"

export default function ProvidersHeader({ name }: any) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleClickBack = (e: any) => {
    navigate(-1)
  }
  const [selectedGroupValue, setSelectedGroupValue] = useState<Array<any>>([])
  const [selectedRegionValue, setSelectedRegionValue] = useState<Array<any>>([])
  const [selectedOfficeValue, setSelectedOfficeValue] = useState<Array<any>>([])
  const [selectAllCheck, setSelectAllCheck] = useState(false)
  const specialityList = useSelector((state: any) => {
    return state.providers.specialityList
  })
  const selectedSpeciality = useSelector((state: any) => {
    return state.providers.selectedSpeciality
  })
  const providersGroupList = useSelector((state: any) => {
    return state.providers.providersGroupList
  })
  const selectedProvidersGroups = useSelector((state: any) => {
    return state.providers.selectedProvidersGroups
  })
  const isAllGroupSelected = useSelector((state: any) => {
    return state.providers.isAllGroupSelected
  })
  const sharedGroupSelection = useSelector((state: any) => state.metric.maevaSelectedGroupsNoAll?.[0])
  const providersRegionList = useSelector((state: any) => {
    return state.providers.providersRegionList
  })
  const selectedProvidersRegions = useSelector((state: any) => {
    return state.providers.selectedProvidersRegions
  })
  const isAllRegionSelected = useSelector((state: any) => {
    return state.providers.isAllRegionSelected
  })
  const providersOfficeList = useSelector((state: any) => {
    return state.providers.providersOfficeList
  })
  const selectedProvidersOffices = useSelector((state: any) => {
    return state.providers.selectedProvidersOffices
  })
  const isAllOfficeSelected = useSelector((state: any) => {
    return state.providers.isAllOfficeSelected
  })
  const providersList = useSelector((state: any) => {
    return state.providers.providersList
  })
  const selectedProviders = useSelector((state: any) => {
    return state.providers.selectedProviders
  })

  const handleSpecialityFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setSelectedSpeciality(value))
    dispatch(setSelectedProviderMetrics([]))
    dispatch(setProvidersMetricTabs([]))
    dispatch(setSelectedProvidersMetricTab({}))
    dispatch(setProvidersData([]))
    dispatch(setProvidersTableData([]))
    dispatch(setSelectedProviders([]))
    dispatch(setIsAllGroupSelected(false))
    dispatch(setIsAllRegionSelected(false))
    dispatch(setIsAllOfficeSelected(false))
  }
  // const handleGroupFilter = (e: any, child: any) => {
  //   const value = e.target.value
  //   const childs = child.props.children

  //   setSelectedGroupValue([])
  //   if (childs === "Apply") {
  //     return
  //   }
  //   if (childs[1] === "Select All") {
  //     setSelectedGroupValue(
  //       (selectedGroupValue && selectedGroupValue.length) ===
  //         (providersGroupList && providersGroupList.length)
  //         ? []
  //         : providersGroupList,
  //     )

  //     //dispatch(setSelectedProvidersGroups(value))
  //     return value
  //   }
  //   setSelectedGroupValue(value)
  //   setSelectedRegionValue([])
  //   setSelectedOfficeValue([])
  //   dispatch(setSelectedProvidersRegions([]))
  //   dispatch(setSelectedProvidersOffices([]))
  //   dispatch(setSelectedProviders([]))
  //   dispatch(setProvidersList([]))
  // }

  const handleGroupFilter = (e: any, child: any) => {
    const value = e.target.value
    const childs = child.props.children
    if (childs === "Apply") {
      return
    }
    if (childs[1] === "Select All") {
      dispatch(setIsAllGroupSelected(!isAllGroupSelected))
      if (!isAllGroupSelected) {
        dispatch(setSelectedProvidersGroups(providersGroupList))
      } else {
        dispatch(setSelectedProvidersGroups([]))
        dispatch(setSelectedProvidersRegions([]))
        dispatch(setSelectedProvidersOffices([]))
        dispatch(setSelectedProviders([]))
        dispatch(setProvidersList([]))
        dispatch(setProvidersMetricTabs([]))
        dispatch(setSelectedProvidersMetricTab({}))
        dispatch(setProvidersTableData([]))
      }
      return value
    }
    dispatch(setIsAllGroupSelected(false))
    dispatch(setIsAllRegionSelected(false))
    dispatch(setSelectedProvidersGroups(value))
    dispatch(setSelectedProvidersRegions([]))
    dispatch(setSelectedProvidersOffices([]))
    dispatch(setSelectedProviders([]))
    dispatch(setProvidersList([]))
    dispatch(setProvidersMetricTabs([]))
    dispatch(setSelectedProvidersMetricTab({}))
    dispatch(setProvidersTableData([]))
  }

  const handleRegionFilter = (e: any, child: any) => {
    const value = e.target.value
    const childs = child.props.children

    if (childs === "Apply") {
      return
    }
    if (childs[1] === "Select All") {
      dispatch(setIsAllRegionSelected(!isAllRegionSelected))
      if (!isAllRegionSelected) {
        dispatch(setSelectedProvidersRegions(providersRegionList))
      } else {
        dispatch(setSelectedProvidersRegions([]))
        dispatch(setSelectedProvidersOffices([]))
        dispatch(setIsAllOfficeSelected(false))
        dispatch(setSelectedProviders([]))
        dispatch(setProvidersList([]))
        dispatch(setProvidersMetricTabs([]))
        dispatch(setSelectedProvidersMetricTab({}))
        dispatch(setProvidersTableData([]))
      }
      return value
    }
    dispatch(setSelectedProvidersRegions(value))
    dispatch(setIsAllOfficeSelected(false))
    dispatch(setSelectedProvidersOffices([]))
    dispatch(setSelectedProviders([]))
    dispatch(setProvidersList([]))
    dispatch(setProvidersMetricTabs([]))
    dispatch(setSelectedProvidersMetricTab({}))
    dispatch(setProvidersTableData([]))
  }

  const handleOfficeFilter = (e: any, child: any) => {
    const value = e.target.value
    const childs = child.props.children
    if (childs === "Apply") {
      return
    }
    if (childs[1] === "Select All") {
      dispatch(setIsAllOfficeSelected(!isAllOfficeSelected))
      if (!isAllOfficeSelected) {
        dispatch(setSelectedProvidersOffices(providersOfficeList))
      } else {
        dispatch(setSelectedProvidersOffices([]))
        dispatch(setSelectedProviders([]))
        dispatch(setProvidersList([]))
        dispatch(setProvidersMetricTabs([]))
        dispatch(setSelectedProvidersMetricTab({}))
        dispatch(setProvidersTableData([]))
      }
      return value
    }
    dispatch(setSelectedProvidersOffices(value))

    dispatch(setSelectedProviders([]))
    dispatch(setProvidersList([]))
    dispatch(setProvidersMetricTabs([]))
    dispatch(setSelectedProvidersMetricTab({}))
    dispatch(setProvidersTableData([]))
  }

  const handleProviderFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setSelectedProviders(value))
  }
  useEffect(() => {
    if (selectedProvidersGroups?.length) {
      dispatch(
        setIsAllGroupSelected(
          selectedProvidersGroups?.length === providersGroupList?.length,
        ),
      )
    } else {
      dispatch(setIsAllGroupSelected(false))
    }
  }, [selectedProvidersGroups])

useEffect(() => {
  // Wait for providersGroupList to be loaded before trying to match
  if (!providersGroupList?.length) return
  
  if (!sharedGroupSelection) return

  const sharedAsArray = Array.isArray(sharedGroupSelection)
    ? sharedGroupSelection
    : [sharedGroupSelection]

  // Match by group_sk against actual list objects
  const matched = providersGroupList.filter((group: any) =>
    sharedAsArray.some((shared: any) => shared.group_sk === group.group_sk)
  )

  if (matched.length) {
    dispatch(setSelectedProvidersGroups(matched))
  }

}, [providersGroupList, sharedGroupSelection])

  useEffect(() => {
    if (selectedProvidersRegions?.length) {
      dispatch(
        setIsAllRegionSelected(
          selectedProvidersRegions?.length === providersRegionList?.length,
        ),
      )
    } else {
      dispatch(setIsAllRegionSelected(false))
    }
  }, [selectedProvidersRegions])

  useEffect(() => {
    if (selectedProvidersOffices?.length) {
      dispatch(
        setIsAllOfficeSelected(
          selectedProvidersOffices?.length === providersOfficeList?.length,
        ),
      )
    } else {
      dispatch(setIsAllOfficeSelected(false))
    }
  }, [selectedProvidersOffices])
  useEffect(() => {
    if (selectedProvidersGroups?.length) {
      dispatch(
        setIsAllGroupSelected(
          selectedProvidersGroups?.length === providersGroupList?.length,
        ),
      )
    } else {
      dispatch(setIsAllGroupSelected(false))
    }
  }, [])

  useEffect(() => {
    if (selectedProvidersRegions?.length) {
      dispatch(
        setIsAllRegionSelected(
          selectedProvidersRegions?.length === providersRegionList?.length,
        ),
      )
    } else {
      dispatch(setIsAllRegionSelected(false))
    }
  }, [])

  useEffect(() => {
    if (selectedProvidersOffices?.length) {
      dispatch(
        setIsAllOfficeSelected(
          selectedProvidersOffices?.length === providersOfficeList?.length,
        ),
      )
    } else {
      dispatch(setIsAllOfficeSelected(false))
    }
  }, [])
  return (
    <>
      <MetricHeaderWrapper>
        <MetricHeaderLeft>
          <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
        </MetricHeaderLeft>

        <MetricHeaderMid>
          <ProvidersHeaderGeneralDropdownFilter
            id={1}
            disabled={false}
            handleFilter={handleSpecialityFilter}
            filterData={specialityList}
            headerLabel="Speciality"
            value={selectedSpeciality}
            placeholder="Select Speciality"
          />
          {/* <MultiSelect
            id={2}
            disabled={!selectedSpeciality}
            handleValue={handleGroupFilter}
            selectedValue={selectedGroupValue}
            setSelectValue={setSelectedGroupValue}
            filterData={providersGroupList}
            selecteGobal={setSelectedProvidersGroups}
            value={selectedProvidersGroups}
            headerLabel="Group"
            placeholder="Select Groups"
            alertMessage="Atleast one Group must be selected"
          />
          <MultiSelect
            id={3}
            disabled={!selectedProvidersGroups?.length}
            handleValue={handleRegionFilter}
            selectedValue={selectedRegionValue}
            setSelectValue={setSelectedRegionValue}
            filterData={providersRegionList}
            selecteGobal={setSelectedProvidersRegions}
            value={selectedProvidersRegions}
            headerLabel="Region"
            placeholder="Select Regions"
            alertMessage="Atleast one Region must be selected"
          />
          <MultiSelect
            id={4}
            disabled={!selectedProvidersRegions?.length}
            handleValue={handleOfficeFilter}
            selectedValue={selectedOfficeValue}
            setSelectValue={setSelectedOfficeValue}
            filterData={providersOfficeList}
            selecteGobal={setSelectedProvidersOffices}
            value={selectedProvidersOffices}
            headerLabel="Office"
            placeholder="Select Offices"
            alertMessage="Atleast one Office must be selected"
          /> */}

          <ProvidersHeaderBasicDropdownMultiFilter
            id={2}
            // disabled={!selectedSpeciality}
            valueKey="group_sk"
            handleFilter={handleGroupFilter}
            filterData={providersGroupList}
            headerLabel="Group"
            value={selectedProvidersGroups}
            placeholder="Select Groups"
            isAllSelected={isAllGroupSelected}
          />
          <ProvidersHeaderBasicDropdownMultiFilter
            id={3}
            useStringMatch={true}
            disabled={!selectedProvidersGroups?.length}
            handleFilter={handleRegionFilter}
            filterData={providersRegionList}
            headerLabel="Region"
            value={selectedProvidersRegions}
            placeholder="Select Regions"
            isAllSelected={isAllRegionSelected}
          />
          <ProvidersHeaderBasicDropdownMultiFilter
            id={4}
            valueKey="practice_sk"
            disabled={!selectedProvidersRegions?.length}
            handleFilter={handleOfficeFilter}
            filterData={providersOfficeList}
            headerLabel="Office"
            value={selectedProvidersOffices}
            placeholder="Select Offices"
            isAllSelected={isAllOfficeSelected}
          />
          <ProvidersHeaderProviderDropdownFilter
            id={5}
            disabled={!selectedProvidersOffices?.length}
            handleFilter={handleProviderFilter}
            filterData={providersList}
            headerLabel="Provider"
            value={selectedProviders}
            placeholder="Select Providers"
            multiple={true}
          />
        </MetricHeaderMid>

        <MetricHeaderRight></MetricHeaderRight>
      </MetricHeaderWrapper>
    </>
  )
}
